import { AxiosRequestConfig } from 'axios';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import { sendAxiosRequest } from '../../utils/sendRequest';
import IFileResponse from '../../../models/responces/IFileResponse';

export interface IApiRelationFileUploadParams {
  dataObjectName: string;
  id: number;
  relationName: string;
  files: File[];
  cfg?: AxiosRequestConfig;
}

const apiRelationFileUpload = (params: IApiRelationFileUploadParams) => {
  const formData = new FormData();
  formData.append('dataObjectName', params.dataObjectName);
  formData.append('relationName', params.relationName);
  formData.append('id', `${params.id}`);
  params.files.forEach((file, idx) => formData.append(`File_${idx}`, file));
  const cfg = params.cfg || {};
  return sendAxiosRequest({
    ...cfg,
    method: 'post',
    headers: {
      Authorization: api.getToken(),
      'Content-Type': 'multipart/form-data'
    },
    url: UrlBuilder.getURL({
      handler: 'file',
      action: 'relation-file-upload'
    }),
    data: formData,
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IFileResponse>;
};

export default apiRelationFileUpload;
